import { Module } from 'vuex';
import { AccountInventoryResultState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

const namespaced: boolean = true;
export const state: AccountInventoryResultState = {
    inventoryResults: undefined,
    inventoryResultBasicInformation: undefined,
    inventoryResultDetails: undefined,
    domainInventoryResultDetails: undefined,
    inventoryResultCount: 0,
    inventoryResultDetailsCount: 0,
    domainInventoryResultDetailsCount: 0,

    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    nodeItems: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    domainItems: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    diff: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    retry: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    csv: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

export const accountInventoryResult: Module<AccountInventoryResultState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
